import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=13c14da7&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=13c14da7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c14da7",
  null
  
)

export default component.exports